﻿import { useQuery } from '@tanstack/react-query';
import { surveyAnalyticsService } from '../../../services/surveyAnalytics.service';
import type { AnalyticsSort, RankingParams } from '../../../types/survey-analytics.types';

export function useAnalyticsRanking(input: {
  surveyId?: string;
  versionId?: string;
  questionId?: string;
  search?: string;
  sort?: AnalyticsSort;
  includeZero?: boolean;
  cursor?: string;
  pageSize?: number;
  enabled?: boolean;
}) {
  const params: RankingParams = {
    search: input.search || undefined,
    sort: input.sort ?? 'COUNT_DESC',
    includeZero: input.includeZero ?? false,
    cursor: input.cursor,
    pageSize: input.pageSize ?? 20,
  };

  return useQuery({
    queryKey: ['survey-analytics-ranking', input.surveyId, input.versionId, input.questionId, params],
    enabled: Boolean(input.enabled ?? true) && Boolean(input.surveyId && input.versionId && input.questionId),
    queryFn: ({ signal }) => surveyAnalyticsService.getRanking(String(input.surveyId), String(input.versionId), String(input.questionId), params, { signal }),
    staleTime: 30_000,
  });
}

export default useAnalyticsRanking;
